// import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

import AiChatLoader from './AiChatLoader';
import AiChatPart from './AiChatPart';

import type { ReactElement } from 'react';
import type IAiChatMessage from '../interfaces/IAiChatMessage';

import styles from '../sass/AiChat.module.scss';

/** Role the API gives the messages the user sent. Everything else is rendered as a reply. */
const USER_ROLE = 'user';

/**
 * One message of a chat.
 *
 * Takes the role and the parts alone, so a reply arriving chunk by chunk and a row loaded from the
 * API go through exactly the same path — the content never branches on where the message came from.
 * `isStreaming` only adds affordances: on a reply, the typing indicator and reasoning held open;
 * on the user's message, a class for the moment between the send and the reply's first chunk.
 */
function AiChatMessage({ message, isStreaming, isLatest }: IAiChatMessage): ReactElement {
  // const { t } = useTranslation();
  const isUser = message.role === USER_ROLE;

  return (
    <article
      className={clsx(
        styles.message,
        isUser ? styles.messageUser : styles.messageAssistant,
        // Sent and not answered yet: the API has not opened its reply, so there is no reply to mark.
        isUser && isStreaming && styles.messageSending,
      )}
    >
      {/* <p className={styles.role}>{isUser ? t('aiChat.roleYou') : t('aiChat.roleAssistant')}</p> */}

      <div className={styles.parts}>
        {message.parts.map((part, index) => (
          // Parts are only ever appended and a stored text part carries no id, so the position in
          // the array is the only stable identity a part has.
          // eslint-disable-next-line react/no-array-index-key
          <AiChatPart key={`${index}-${part.type}`} part={part} />
        ))}

        {/* The mark sits on the newest reply alone, and turns only while that reply is written. */}
        {isLatest && !isUser ? (
          <AiChatLoader spinning={isStreaming} className={styles.typing} />
        ) : null}
      </div>
    </article>
  );
}

export default AiChatMessage;
